<template>
  <div
    class="tooltip-wrapper"
    @mouseenter="show = true"
    @mouseleave="show = false"
  >
    <!-- slot para o elemento principal -->
    <slot></slot>

    <!-- tooltip -->
    <transition name="fade">
      <div
        v-if="show"
        class="tooltip-box"
        :class="position"
      >
        <!-- slot para conteúdo do tooltip -->
        <slot name="content">{{ text }}</slot>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Tooltip',
  props: {
    text: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: 'top', // top | bottom | left | right
    },
  },
  data() {
    return {
      show: false,
    }
  },
}
</script>

<style scoped>
.tooltip-wrapper {
  position: relative;
  display: inline-block;
}

.tooltip-box {
  position: absolute;
  z-index: 99999;
  background: #333;
  color: #fff;
  font-size: 18px;
  padding: 6px 10px;
  border-radius: 4px;
  white-space: pre; /* mantém \n */
  overflow-wrap: normal; /* evita quebra de palavras */
  word-break: normal; /* evita quebra de palavras */  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: max-content;
  max-width: none;
}

/* posições */
.tooltip-box.top {
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 6px;
}

.tooltip-box.bottom {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 6px;
}

.tooltip-box.left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 6px;
}

.tooltip-box.right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 6px;
}

/* animação */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
